import { useEffect, useState } from "react";
import akcoda from "../../assets/AKCODA-02.png";
import { Link } from "react-router-dom";
const Footer = () => {
  const [currentYear, setYear] = useState("");

  const handleUpArrow = () => {
    let yheight = window.innerWidth;

    if (yheight < 768) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  useEffect(() => {
    const year = new Date().getFullYear();
    setYear(year);
  }, []);

  return (
    <>
      <div
        className="container-fluid p-0"
        style={{ background: "linear-gradient(to right, #3e13c0ff ,  #426fecff)" }}
      >
        <div className="container servicesContent" style={{ padding: "50px" }}>
          <div className="row text-secondary">
            <div className="col-12 text-end">
              <button
                style={{ backgroundColor: "transparent", border: "none" }}
                onClick={handleUpArrow}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="30"
                  height="30"
                  fill="currentColor"
                  className="bi bi-arrow-up-circle-fill text-light rounded"
                  viewBox="0 0 16 16"
                >
                  <path d="M16 8A8 8 0 1 0 0 8a8 8 0 0 0 16 0m-7.5 3.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3a.5.5 0 0 1 .708 0l3 3a.5.5 0 1 1-.708.708L8.5 5.707z" />
                </svg>
              </button>
            </div>

            <div className="col-md-3">
              <img
                src={akcoda}
                alt="akcoda"
                style={{
                  width: "120px",
                  height: "70px",
                  borderRadius: "10px",
                }}
              />
              <p style={{ color: "#ffffff" }}>WE ARE THE FUTURE</p>
            </div>

            <div className="col-md-3 quicklinks">
              <h5 style={{ color: "#ffffff" }}>Quick Links</h5>
              <ul style={{ listStyleType: "none", color: "#ffffff" }} className="p-0">
                <li><Link to="/">Home</Link></li>
                <li><Link to="/service">About</Link></li>
                <li><Link to="/contact">Contact</Link></li>
                <li><Link to="/policy">Privacy Policy</Link></li>
                <li><Link to="/term">Terms & Condition</Link></li>
              </ul>
            </div>

            <div className="col-md-3 service">
              <h5 style={{ color: "#ffffff" }}>Services</h5>
              <ul style={{ listStyleType: "none" }} className="p-0">
                <li><Link to="/website">Website Development</Link></li>
                <li><Link to="/ecommerce">Ecommerce Development</Link></li>
                <li><Link to="/androidios">Android App Development</Link></li>
                <li>
                  <a href="https://wa.me/+918851042421" target="_blank" rel="noreferrer">
                    Custom App Development
                  </a>
                </li>
              </ul>
            </div>

            <div className="col-md-3 contact">
              <h5 style={{ color: "#ffffff" }}>Contact</h5>
              <ul style={{ listStyleType: "none" }} className="p-0">
                <li>
                  <i className="bi bi-envelope-fill"></i>{" "}
                  <a href="mailto:info@akcoda.in" style={{ color: "#ffffff" }}>
                    info@akcoda.in
                  </a>
                </li>
                <li>
                  <i class="bi bi-telephone-fill"></i>{" "}
                  <a href="tel:+918851042421" style={{ color: "#ffffff" }}>
                    +91-88510-42-421
                  </a>
                </li>
                <li>
                  <i class="bi bi-phone-fill"></i>{" "}
                  <a href="tel:+918700364602" style={{ color: "#ffffff" }}>
                    +91-8700-36-4602
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="text-center py-1" style={{background:'black'}}>
          <p className="text-light">Copyright <span>{currentYear}</span> © AKCODA. All Rights Reserved.</p>
        </div>
      </div>
    </>
  );
};

export default Footer;
